import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Search: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.579 11.816a6 6 0 1 1 1.238-1.238l3.427 3.428a.875.875 0 1 1-1.238 1.238l-3.427-3.428ZM11.25 7a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0Z"
            ></path>
        </Icon>
    );
};
